import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './card.css';
import styles from './card.css.json';
import * as importedActions from './actions';

class LoadingComponent extends Component {
  componentWillMount() {
    this.props.resetLoading();
  }

  render() {
    return (
      <div
        className={
          this.props.loading &&
          this.props.loading.pendingApiArray &&
          this.props.loading.pendingApiArray.length
            ? styles.scrolling
            : styles.scrolled
        }
      >
        <div
          style={{
            display:
              this.props.loading &&
              this.props.loading.pendingApiArray &&
              this.props.loading.pendingApiArray.length
                ? 'flex'
                : 'none',
          }}
          className={styles.loadingContainer}
        >
          <div className={styles['lds-facebook']}>
            <div />
            <div />

            <div />
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loading } = state;

  return {
    loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...importedActions,
    },
    dispatch,
  );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoadingComponent));



// WEBPACK FOOTER //
// ./src/shells/LoadingComponent/index.jsx